<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <el-button :size="size" icon="el-icon-search"  v-if="showButton('search')" @click="searchDepartmentInfo">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp('0')">添加</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        row-key="departId"
        :data="departmentList"
        height="100%"
        v-loading="loading"
        :tree-props="{children: 'childrens', hasChildren: 'hasChildren'}">
        <el-table-column prop="departId" label="部门ID" sortable align="center"></el-table-column>
        <el-table-column prop="departName" label="部门名称" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="300">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('insert')" @click="insertProp(row.departId)">添加</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '添加' : '修改'"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="部门名称：" prop="departName">
          <el-input v-model="ruleForm.departName" :size="size" clearable placeholder="请输入部门名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()"> 提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        insertState: '0', // 添加状态 0根部门添加
        loading: false,
        departmentList: [], // 部门列表信息
        asyncTitle: true, // 对话框title true 添加  false 修改
        asyncVisible: false, // 添加 修改部门对话框
        ruleForm: {}, // 部门表单
        rules: {
          departName: [{
            required: true,
            message: '请输入部门名称',
            trigger: 'blur'
          }]
        }
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.insertState = '0';
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchDepartmentInfo();
    },
    methods: {
      // 查询部门信息
      searchDepartmentInfo() {
        this.$api.System.searchDepartmentInfo({}).then(res => {
          this.departmentList = res.data;
        })
      },
      // 添加部门信息
      insertProp(num) {
        this.asyncTitle = true;
        this.asyncVisible = true;
        this.insertState = num;
      },
      // 修改部门信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.$set(this.ruleForm, 'departId', row.departId);
        this.$set(this.ruleForm, 'departName', row.departName);
        this.$set(this.ruleForm, 'parentId', row.parentId);
        this.$set(this.ruleForm, 'version', row.version);
      },
      // 删除部门信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该部门，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.System.deleteDepartmentInfo({departId: row.departId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchDepartmentInfo();
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加部门信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.parentId = this.insertState;
            this.$api.System.insertDepartmentInfo(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchDepartmentInfo();
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改部门信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.System.updateDepartmentInfo(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchDepartmentInfo();
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>